import React, { useRef, useEffect, useState } from "react";

const DynamicDropdown = ({ options = [], onSelect, placeholder = "Select...", icon, className = "" }) => {
    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(placeholder);
    const ref = useRef();

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        setSelectedValue(option.label);
        setOpen(false);
        if (onSelect) {
            onSelect(option);
        }
    };

    return (
        <div ref={ref} className={`dropdown_wrapper ${className}`}>
            <button
                className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
                type="button"
                onClick={() => setOpen((prev) => !prev)}
                style={{ minWidth: '150px' }}
            >
                {icon && <i className={`${icon} me-2`}></i>}
                <span className="flex-grow-1 text-start">{selectedValue}</span>
            </button>
            
            {open && (
                <ul className="dropdown-menu show" style={{ minWidth: '150px' }}>
                    {options.map((option, index) => (
                        <li key={index}>
                            <button
                                className="dropdown-item d-flex align-items-center"
                                onClick={() => handleSelect(option)}
                            >
                                {icon && <i className={`${icon} me-2`}></i>}
                                {option.label}
                                {selectedValue === option.label && (
                                    <i className="bi bi-check ms-auto text-primary"></i>
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default DynamicDropdown;